
import Vue from "vue"
import { mapActions, mapState } from "vuex"
import ActionDialog from "@/components/ActionDialog.vue"
import EventsDivisionsForm from "./EventsDivisionsForm.vue"

export default Vue.extend({
  name: "EventsDivisionsEditDialog",

  components: {
    ActionDialog,
    EventsDivisionsForm
  },

  props: {
    shown: { type: Boolean, default: false },
    division: { type: Object, required: true }
  },

  data: function() {
    return {
      visible: this.shown,
      form: { ...EventsDivisionsForm }
    }
  },

  computed: mapState("events/divisions", {
    eventsDivisionsStateEditOneIsLoading: "editOneIsLoading"
  }),

  watch: {
    visible(visible): void {
      this.$emit("update:shown", visible)
    },
    shown(visible): void {
      this.visible = visible
    },
    division: {
      immediate: true,
      handler(data): void {
        this.form = { ...data }
      }
    }
  },

  methods: {
    ...mapActions("events/divisions", {
      eventsDivisionsActionsEditOne: "editOne"
    }),

    submit(): void {
      this.$refs.eventsDivisionsForm.submit(async () => {
        try {
          await this.eventsDivisionsActionsEditOne(this.form)
          this.$success(this.$t("eventsDivisionsActionsEditOneSuccess", {
            divisionDay: this.form.day,
            divisionStartsAt: this.form.startsAt
          }))
          this.close()
        } catch(e) {
          this.$error(e.message)
        }
      })
    },

    close(): void {
      this.visible = false
    }
  }
})
